(function () {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  if (document.body.classList.contains("st-no-anim")) return;

  var nodes = document.querySelectorAll("[data-st-reveal]");
  if (!nodes.length || !("IntersectionObserver" in window)) return;

  nodes.forEach(function (el) {
    el.classList.add("st-reveal", "is-pending");
  });

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-in");
        entry.target.classList.remove("is-pending");
        io.unobserve(entry.target);
      });
    },
    { rootMargin: "0px 0px -8% 0px", threshold: 0.12 }
  );

  nodes.forEach(function (el) {
    io.observe(el);
  });
})();
